import React, { useEffect, useState } from "react";
import useModal from "hooks/useModal";
import StepScreenContainer from "components/visitCommon/StepScreenContainer";
import Spacer from "components/Spacer/Spacer";
import Card from "components/visitCommon/Card";
import RadioButtonCard from "components/radioButtonCard/RadioButtonCard";
import Button from "components/buttons/Button";
import AddSomeoneElseModal from "../../common/AddSomeoneElseModal";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import useVisitStepChange from "hooks/useVisitStepChange";
import { useBehaviorHealthVisitFlow } from "hooks/useVisitFlow";
import { bh_sub_steps, speciality } from "helpers/enum";
import useCreateBehaviorHealthVisit from "hooks/visit/useCreateBehaviorHealthVisit";
import useUpdateBehaviorHealthVisit from "hooks/visit/useUpdateBehaviorHealthVisit";
import { behaviorHealthVisitFlowReducers } from "reducers/behavior_health/behaviorHealthVisitFlowReducer";
import MedicalAssistant from "components/MedicalAssistant/MedicalAssistant";

function SelectSomeoneElse() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { rightButtonClickRef } = useVisitStepChange();
  rightButtonClickRef.current = onRightButtonClick;
  const { setShowModal } = useModal();
  const [selected, setSelected] = useState(null);
  const {
    patientsList,
    incompleteData,
    subSteps,
  } = useBehaviorHealthVisitFlow();
  const currentScreenValueFromStore =
    subSteps[bh_sub_steps.select_someone_else].value;

  const { createNewVisit, creatingVisit } = useCreateBehaviorHealthVisit();
  const { updateVisit, updatingVisit } = useUpdateBehaviorHealthVisit();

  useEffect(() => {
    if (currentScreenValueFromStore) {
      setSelected(currentScreenValueFromStore);
    }
  }, [currentScreenValueFromStore, patientsList]);

  useEffect(() => {
    if (selected?.length) {
      dispatch(
        behaviorHealthVisitFlowReducers.select_someone_else({
          isValid: true,
        })
      );
    } else {
      dispatch(
        behaviorHealthVisitFlowReducers.select_someone_else({
          isValid: false,
        })
      );
    }
  }, [dispatch, selected]);

  function onRightButtonClick() {
    if (incompleteData && Object.keys(incompleteData)?.length) {
      updateVisit({
        payload: {
          case: {
            id: incompleteData?.id,
            patient_id: patientsList?.find((el) => el?.full_name === selected)
              ?.id,
            behavior_health_steps: incompleteData?.behavior_health_steps,
          },
        },
        change_current_screen: false,
        screen_to_complete: null,
        callBack: () => {
          dispatch(
            behaviorHealthVisitFlowReducers.select_someone_else({
              value: selected,
            })
          );
          history.push("/visit/behavior-health/pricing");
        },
      });
    } else {
      createNewVisit({
        patient_id: patientsList?.find((el) => el?.full_name === selected)?.id,
        change_current_screen: false,
        screen_to_complete: null,
        callBack: () => {
          dispatch(
            behaviorHealthVisitFlowReducers.select_someone_else({
              value: selected,
            })
          );
          history.push("/visit/behavior-health/pricing");
        },
      });
    }
  }

  return (
    <StepScreenContainer>
      <MedicalAssistant content={<p>Please, select patient.</p>} />
      <Spacer height={40} />
      <Card>
        <RadioButtonCard
          loading={creatingVisit}
          options={patientsList
            ?.filter(
              (patient) =>
                patient?.relationship_with_account &&
                patient.relationship_with_account !== "myself" &&
                patient.relationship_with_account !== "pappa"
            )
            ?.map((el) => el?.full_name)}
          onSelect={setSelected}
          selected={selected}
        />
        <Spacer height="38" />
        <Button
          disabled={updatingVisit}
          onClick={() => {
            setShowModal({
              state: true,
              children: (_, onClose) => (
                <AddSomeoneElseModal
                  onClose={(e) => {
                    if (e !== null) {
                      setSelected(e);
                    }
                    onClose();
                  }}
                  currentSpeciality={speciality.behavior_health}
                />
              ),
              data: null,
            });
          }}
          label="Add Patient"
          outlined
        />
      </Card>
    </StepScreenContainer>
  );
}

export default SelectSomeoneElse;
